<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="100px" class="approveForm">
                <el-row>
                    <el-form-item label="启用状态">
                        <el-select v-model="params.status" clearable>
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            </div>
        </div>
        
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增账号</el-button>
            <div class="ps">PS: 新增账号或重置账号后的默认密码为 123456 ，Google秘钥由系统生成。</div>
        </div>
       
        <el-table border :data="tableData" class="table-show-current" highlight-current-row @row-dblclick="openUpdate" @current-change="changeCurrentRow">
            <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
            <el-table-column prop="name" label="账号" align="center" width="300"></el-table-column>
            <!--
            <el-table-column prop="realName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="phoneNo" label="联系方式" align="center"></el-table-column>
            -->
            <el-table-column prop="roleList" label="角色" align="center">
                <template slot-scope="scope">{{scope.row.superUser == "Y"?"超级管理员":showRole(scope.row)}}</template>
            </el-table-column>
            <el-table-column prop="status" label="启用状态" align="center">
                <template slot-scope="scope">{{statusMap[scope.row.status]}}</template>
            </el-table-column>
            <el-table-column prop="googleKey" label="Google秘钥" align="center"></el-table-column>
            <el-table-column prop="comments" label="备注" align="center" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" align="center" width="150"></el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope" v-if="scope.row.id != 1">
                    <el-button type="text" icon="el-icon-refresh" @click="resetUser(scope.row)">重置账号</el-button>
                    <el-button type="text" icon="el-icon-delete"  @click="deleteUser(scope.row)">删除账号</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
        <el-pagination background layout="total,sizes, prev, pager, next" :current-page="pageInfo.pageNum"
                        :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 50, 100, 200]" :total="total"
                        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" class="abow_dialog">
            <el-form ref="formRef" :rules="rules" :model="form" label-width="150px" class="approveForm">
                <el-row v-if="isCreate">
                    <el-form-item>
                        <div class="ps">PS: 新增账号的初始默认密码为 123456 ，Google秘钥由系统生成。</div>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="账号" prop="name">
                        <el-input placeholder v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态" prop="status">
                        <el-select v-model="form.status">
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <!-- 
                <el-row>
                    <el-form-item label="姓名">
                        <el-input placeholder v-model="form.realName"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input placeholder v-model="form.phoneNo"></el-input>
                    </el-form-item>
                </el-row>
                -->
                <el-row>
                    <el-form-item label="是否为超级管理员" prop="superUser">
                        <el-select v-model="form.superUser" @change="chagneSuperUser">
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色">
                        <el-select v-model="form.roleId" :disabled = "form.superUser == 'Y'">
                            <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="form.comments"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onSubmit" type="primary" >提交</el-button>
                <el-button @click="onCancel">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { userServiceApi,roleServiceApi } from '@/api/api-auth';
export default {
    data() {
        return {
            statusOptions:[],
            statusMap:{},
            roleList: [],
            rules: {
                name: [{ required: true, message: '不能为空' }],
                superUser: [{ required: true, message: '不能为空' }],
                status: [{ required: true, message: '不能为空' }],
                roleIdList:[{ required: true, message: '不能为空' }],
            },
            tableData: [],
            total: 0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            params:{},
            dialogVisible: false,
            dialogTitle:"",
            isCreate:false,
            form: {},
            currentRow:null,
        };
    },
    created() {
        this.statusOptions = this.findDict("yesOrNo");
        this.statusMap = this.listToMap(this.statusOptions,"code","name");
        roleServiceApi.findAll().then(res => {
            this.roleList = res;
        });
        this.handleSearch();
    },
    methods: {
        handleSearch() {
            userServiceApi.findPageList(this.params, this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        chagneSuperUser(){
            if(this.form.superUser == "Y"){
                this.form.roleId = null;
            }
        },
        showRole(data){
            if(data.superUser=='Y'){
                return "全部";
            }else if(data.roleList && data.roleList.length>0){
                let roleNameList = [];
                data.roleList.map((i, n) => {
                    roleNameList.push(i.name);
                });
                return roleNameList.join(",");
            }else{
                return "";
            }
        },
        changeCurrentRow(val) {
            this.currentRow = val;
        },
        openCreate() {
            this.form = {status: 'Y',type: 'USER',roleIdList: []};
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            this.dialogTitle = "新增账号";
            this.dialogVisible = true;
            this.isCreate = true;
        },
        openUpdate(data){
            this.form = JSON.parse(JSON.stringify(data));
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            // this.form.roleIdList = [];
            // if(this.form.roleList && this.form.roleList.length>0){
            //     let roleIdList = [];
            //     this.form.roleList.map((i, n) => {
            //         roleIdList.push(i.id);
            //     });
            //     this.form.roleIdList = roleIdList;
            // }
            if(this.form.roleList && this.form.roleList.length>0){
                this.form.roleId = this.form.roleList[0].id;
            }
            this.dialogTitle = "修改账号";
            this.dialogVisible = true;
            this.isCreate = false;
        },
        deleteUser(data){
            this.$confirm('确定删除此账号吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                userServiceApi.delete(data).then(res => {
                    if (res.result) {
                        this.$message.success('删除成功');
                        this.handleSearch();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            });
        },
        resetUser(data) {
            this.$confirm('确定重置此账号的密码和Google秘钥吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                userServiceApi.resetUser(data).then(res => {
                    if (res.result) {
                        this.$message.success('重置成功');
                        this.handleSearch();
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            });
        },
        onSubmit() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    return;
                }
                userServiceApi.update(this.form).then(res => {
                    if (res.result) {
                        this.$message.success('操作成功');
                        this.onCancel();
                        this.handleSearch();
                    } else {
                        if(res.msg){
                            this.$message.error(res.msg);
                        }else{
                            this.$message.error("操作失败");
                        }
                    }
                });
            });
        },
        onCancel() {
            this.$refs.formRef.resetFields();
            this.dialogVisible = false;
        }
    }
};
</script>

<style lang='less'>
.table-button {
    .el-button {
        padding: 3px 5px !important;
        font-size: 12px !important;
    }
}
</style>
